<template>
    <Modal
        v-model="isBox"
        :title="title"
        :fullscreen="true"
        :mask-closable="false"
        :footer-hide="true"
        @on-cancel="FormReset()">
        <div>
            <Table ref="selection" :stripe="true" border  :loading="$store.state.loading" :columns="columns" size="small" :data="dataList" show-summary  :summary-method="handleSummary"   no-data-text="暂无数据记录">
                <template #status="{ row }">
                    <Badge v-if="row.status === 1" status="processing" text="待审批" />
                    <Badge v-else-if="row.status === 2" status="primary" text="待经理审批" />
                    <Badge v-else-if="row.status === 3" status="primary" text="待合作审批" />
                    <Badge v-else-if="row.status === 4" status="error" text="审批驳回" />
                    <Badge v-else-if="row.status === 5" status="warning" text="待打款" />
                    <Badge v-else-if="row.status === 6" status="error" text="打款驳回" />
                    <Badge v-else-if="row.status === 7" status="success" text="已打款" />
                    <Badge v-else status="warning" text="其他" />
                </template>
            </Table>
        </div>
    </Modal>
</template>

<script>

import { getCompanyBillList } from "@/apis/expend";

export default {
    name: 'CompanyBill',
    components: {
    },
    data () {
        return {
            title : '账单明细',
            isBox : false,
            dataList: [],
            columns: [
                {
                    title: '日期',
                    key: 'create_time',
                    width:120
                },
              {
                title: '所属项目',
                key: 'project_name'
              },
              {
                    title: '采购项目',
                    key: 'buyer_title'
                },
                {
                    title: '采购金额',
                    key: 'money',
                    align: 'center'
                },
                {
                    title: '支付金额',
                    key: 'pay_money',
                    align: 'center'
                },
                {
                    title: '支付时间',
                    key: 'pay_time',
                    align: 'center'
                },
                {
                    title: '类型',
                    key: 'type_name',
                    align: 'center'
                },
                {
                    title: '状态', //审核中/已到账/未到账
                    key: 'status',
                    slot: 'status',
                    align: 'center'
                }
            ],

        }
    },
    methods: {
        /**
         功能：表格底部统计
         time: 2025/12/16 15:36
         **/
        handleSummary ({ columns, data }) {
            const sums = {};
            columns.forEach((column, index) => {
                const key = column.key;
                if (index === 0) {
                    sums[key] = {
                        key,
                        value: '总价'
                    };
                    return;
                }
                const values = data.map(item => Number(item[key]));
                if (!values.every(value => isNaN(value))) {
                    const v = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index === 2 || index === 3 || index === 4 || index === 5){
                        sums[key] = {
                            key,
                            value: v + ' 元'
                        };
                    }else{
                        sums[key] = {
                            key,
                            value: '-'
                        };
                    }

                } else {
                    sums[key] = {
                        key,
                        value: '-'
                    };
                }
            });

            return sums;
        },

        /**
         功能：获取客户账单
         time: 2025/12/16 11:08
         **/
        getCompanyBillList(company_id){
            let that = this;
            if(company_id){
                that.$store.commit('SET_LOADING' , true);
                getCompanyBillList(company_id).then(e => {
                    that.dataList = e.data ? e.data : [];
                })
            }
        },
        /**
         功能：
         time: 2025/12/16 11:13
         **/
        show(company_id, company){
            this.isBox = true;
            this.getCompanyBillList(company_id);
            this.title = company +" - 账单明细";
        },
        /**
         功能：
         time: 2025/12/16 11:15
         **/
        FormReset(){
            this.isBox = false;
            this.title = '账单明细';
            this.dataList = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
